var _excluded = ["className", "hidden", "options", "optGroups", "disabled", "input", "meta", "renderPrefix", "style"];
var _templateObject, _templateObject2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import { values, mapValues } from 'lodash';
import styled from 'styled-components';
import ArrowDownIcon from '../Icons/ArrowDown';
import Option from './Option';
import FlexContainer from '../FlexContainer';
import Cushion from '../Cushion';
import Typography from '../Typography';
var SelectContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  border-color: ", "\n  border-style: solid;\n  border-radius: 3px;\n  border-width: 1px;\n  box-shadow: rgba(6, 67, 95, 0.3) 0px 1px 1px, rgba(0, 0, 0, 0.1) 0px 2px 3px;\n  box-sizing: border-box;\n  color: ", "};\n  height: 40px;\n  font-size: 14px;\n  line-height: 1.3;\n  position: relative;\n  width: 100%;\n\n  ", "\n  ", "\n"])), function (props) {
  return props.disabled ? '#F3F3F3' : '#FFF';
}, function (props) {
  return props.error ? '#E26868;' : '#f9f9f9';
}, function (props) {
  return props.disabled ? '#B2B2B2' : '#333';
}, function (props) {
  return props.hidden ? 'display: none;' : '';
}, function (props) {
  return props.disabled ? 'cursor: not-allowed;' : '';
});
var StyledSelect = styled.select(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  appearance: none;\n  background: none;\n  border: none;\n  box-sizing: inherit;\n  color: inherit;\n  cursor: inherit;\n  flex-grow: 1;\n  font-size: inherit;\n  height: inherit;\n  line-height: inherit;\n  outline: 0;\n  padding-left: 12px;\n  padding-right: 34px;\n  position: relative;\n  width: 100%;\n  z-index: 1;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n"])));
var Select = function Select(props) {
  var className = props.className,
    hidden = props.hidden,
    options = props.options,
    optGroups = props.optGroups,
    disabled = props.disabled,
    input = props.input,
    _props$meta = props.meta,
    _props$meta$touched = _props$meta.touched,
    touched = _props$meta$touched === void 0 ? false : _props$meta$touched,
    _props$meta$error = _props$meta.error,
    error = _props$meta$error === void 0 ? false : _props$meta$error,
    renderPrefix = props.renderPrefix,
    customStyle = props.style,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectContainer, {
    style: customStyle,
    error: touched && error,
    hidden: hidden,
    disabled: disabled,
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: '100%',
      borderRadius: '3px 0 0 3px'
    }
  }, /*#__PURE__*/React.createElement(FlexContainer, {
    style: {
      height: 'inherit'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 'inherit',
      borderRadius: '3px 0 0 3px'
    }
  }, renderPrefix()), /*#__PURE__*/React.createElement(StyledSelect, _extends({}, input, other, {
    disabled: disabled,
    hidden: hidden
  }), options && options.map(function (option) {
    return /*#__PURE__*/React.createElement(Option, {
      key: option.value,
      name: option.name,
      value: option.value,
      disabled: !!option.disabled
    });
  }), optGroups && values(mapValues(optGroups, function (value, key) {
    return /*#__PURE__*/React.createElement("optgroup", {
      label: key,
      key: key
    }, value.map(function (option) {
      return /*#__PURE__*/React.createElement(Option, {
        key: option.value,
        name: option.name,
        value: option.value,
        disabled: !!option.disabled
      });
    }));
  })))), !disabled && /*#__PURE__*/React.createElement(ArrowDownIcon, {
    className: "prui-select__icon",
    size: 10,
    color: "#999",
    style: {
      cursor: 'inherit',
      position: 'absolute',
      top: '50%',
      right: 12,
      transform: 'translateY(-50%)',
      zIndex: 0
    }
  }))), touched && error && /*#__PURE__*/React.createElement(Cushion, {
    top: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "label",
    preset: "description",
    color: "#E26868"
  }, error)));
};
Select.defaultProps = {
  className: null,
  input: null,
  optGroups: null,
  options: [],
  disabled: false,
  hidden: false,
  renderPrefix: function renderPrefix() {
    return null;
  },
  meta: {},
  style: {}
};
export default Select;